import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _PinLightRight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M10.364 4.91c-.653-.436-.98-.654-1.335-.618-.356.035-.633.312-1.188.867L5.159 7.841c-.554.555-.832.832-.867 1.188s.182.682.618 1.335l1.648 2.473c.562.843.843 1.264 1.067 1.714a8 8 0 0 1 .427 1.031c.16.477.26.974.458 1.967l.19.955.002.006a1 1 0 0 0 1.547.625l.006-.004.026-.018a35 35 0 0 0 8.832-8.832l.019-.027.003-.005a1 1 0 0 0-.631-1.548l-.955-.191c-.993-.199-1.49-.298-1.966-.458a8 8 0 0 1-1.032-.427c-.45-.224-.87-.505-1.714-1.067z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M19.586 19.586 15.5 15.5" })));
}
const PinLightRight = forwardRef(_PinLightRight);
export { PinLightRight };
